import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { Colors } from "./constant";
import "./index.css";
import { UnifiedLoginGuard } from "@turiya/login-component";
import { LoadingScreen } from "./view/pages/LoadingScreen";

import config from "./config";

const Login = lazy(() =>
  import("./view/pages/Login").then((m) => ({ default: m.Login }))
);
const ChallengeScreen = lazy(() =>
  import("./view/components/ChallengeScreen")
);

const authConfig = {
  env: config.mode,
  appId: config.applicationId,
  baseUrl: config.baseURL,
  processKey: config.definationKey,
  businessKey: config.bussinessKey,
};

const theme = createTheme({
  palette: {
    primary: { main: Colors.dark },
    secondary: { main: Colors.dark },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider theme={theme}>
      <Suspense fallback={<LoadingScreen />}>
        <UnifiedLoginGuard
          clientId="unified-turiya-app-protium-corporate-consumer"
          baseUrl={authConfig.baseUrl}
          loginScreenOverrides={{
            loading: () => <LoadingScreen />,
            userLogin: (props) => (
              <Suspense fallback={<LoadingScreen />}>
                <Login {...props} />
              </Suspense>
            ),
            workflowChallenge: (props) => (
              <Suspense fallback={<LoadingScreen />}>
                <ChallengeScreen {...props} />
              </Suspense>
            ),
          }}
        >
          <App />
        </UnifiedLoginGuard>
      </Suspense>
    </MuiThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
